import React from 'react';
import { View,Text } from 'react-native';
import { FontAwesome5 } from '@expo/vector-icons';

const eseguro=()=>{
return(
   <View style={{width:'100%',height:'100%',backgroundColor:'#01150E',alignItems:'center'}}>
    <View style={{margin:20,backgroundColor:'#01150E'}}>
    <Text style={{color:'white'}}>É UMA TRANSAÇÃO SEGURA ?
    ALÉM DE 100% SEGURA É UMA OPERAÇÃO LEGALIZADA.
    A CCB ( CÉDULA DE CRÉDITO BANCÁRIO ) GARANTE A SEGURANÇA DE UM EMPRÉSTIMO PESSOAL TRANSPARENTE, TRIBUTADO E 100% LEGALIZADO.</Text></View>
    <FontAwesome5 name="user-lock" size={60} color="white" />
   </View>);

}

export default eseguro